/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Location_TransitInputs */

const en_reference_location_transit = /** @type {(inputs: Reference_Location_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In transit`)
};

/**
* | output |
* | --- |
* | "In transit" |
*
* @param {Reference_Location_TransitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_location_transit = /** @type {((inputs?: Reference_Location_TransitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Location_TransitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_location_transit(inputs)
});